// Module
var code = `<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="{{ chart_id }}"></bfg-chart>
    </div>
</div>

<div class="row">
    <table class="table" ng-table fixed-table-headers="scrollable-area">
        <tr>
            <th>Date</th>
            <th>Installs</th>
            <th>0</th>
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>4</th>
            <th>5</th>
            <th>6</th>
            <th>7</th>
            <th>14</th>
            <th>30</th>
            <th>60</th>
            <th>90</th>
            <th>120</th>
            <th>150</th>
            <th>180</th>
            <th>365</th>
            <th>540</th>
            <th>720</th>
            <th>Max Date</th>
        </tr>
        <tr style="background-color: #FFEBCD">
            <td>Average</td>
            <td>{{apply(data[0].Inst)}}</td>
            <td>{{apply(data[0].Day_0)}}</td>
            <td>{{apply(data[0].Day_1)}}</td>
            <td>{{apply(data[0].Day_2)}}</td>
            <td>{{apply(data[0].Day_3)}}</td>
            <td>{{apply(data[0].Day_4)}}</td>
            <td>{{apply(data[0].Day_5)}}</td>
            <td>{{apply(data[0].Day_6)}}</td>
            <td>{{apply(data[0].Day_7)}}</td>
            <td>
                {{apply(data[0].Day_14)}}
                <span class="prediction" ng-if="data[0].Day14_Prediction">({{ apply(data[0].Day14_Prediction) }})</span>
            </td>
            <td>
                {{apply(data[0].Day_30)}}
                <span class="prediction" ng-if="data[0].Day30_Prediction">({{ apply(data[0].Day30_Prediction) }})</span>
            </td>
            <td>
                {{apply(data[0].Day_60)}}
                <span class="prediction" ng-if="data[0].Day60_Prediction">({{ apply(data[0].Day60_Prediction) }})</span>
            </td>
            <td>
                {{apply(data[0].Day_90)}}
                <span class="prediction" ng-if="data[0].Day90_Prediction">({{ apply(data[0].Day90_Prediction) }})</span>
            </td>
            <td>
                {{apply(data[0].Day_120)}}
                <span class="prediction" ng-if="data[0].Day120_Prediction">({{apply(data[0].Day120_Prediction)}})</span>
            </td>
            <td>
                {{apply(data[0].Day_150)}}
                <span class="prediction" ng-if="data[0].Day150_Prediction">({{apply(data[0].Day150_Prediction)}})</span>
            </td>
            <td>
                {{apply(data[0].Day_180)}}
                <span class="prediction" ng-if="data[0].Day180_Prediction">({{apply(data[0].Day180_Prediction)}})</span>
            </td>
            <td>{{apply(data[0].Day_365)}}</td>
            <td>{{apply(data[0].Day_540)}}</td>
            <td>{{apply(data[0].Day_720)}}</td>
            <td>{{apply(data[0].Max_Date)}}</td>
        </tr>
        <tr ng-repeat="day in data.slice(1, data.length)">
            <td>{{day.Date}}</td>
            <td><a ui-sref="amt.ww2.life_time.players_purchases({'date': day.Date})">{{day.Inst}}</a></td>
            <td ng-style="{'background-color': apply_color(day.Day_0, 'Day_0')}">{{apply(day.Day_0)}}</td>
            <td ng-style="{'background-color': apply_color(day.Day_1, 'Day_1')}">{{apply(day.Day_1)}}</td>
            <td ng-style="{'background-color': apply_color(day.Day_2, 'Day_2')}">{{apply(day.Day_2)}}</td>
            <td ng-style="{'background-color': apply_color(day.Day_3, 'Day_3')}">{{apply(day.Day_3)}}</td>
            <td ng-style="{'background-color': apply_color(day.Day_4, 'Day_4')}">{{apply(day.Day_4)}}</td>
            <td ng-style="{'background-color': apply_color(day.Day_5, 'Day_5')}">{{apply(day.Day_5)}}</td>
            <td ng-style="{'background-color': apply_color(day.Day_6, 'Day_6')}">{{apply(day.Day_6)}}</td>
            <td ng-style="{'background-color': apply_color(day.Day_7, 'Day_7')}">{{apply(day.Day_7)}}</td>
            <td ng-style="{'background-color': apply_color(day.Day_14, 'Day_14')}">
                {{apply(day.Day_14)}}
                <span class="prediction" ng-if="day.Day14_Prediction">({{ apply(day.Day14_Prediction) }})</span>
            </td>
            <td ng-style="{'background-color': apply_color(day.Day_30, 'Day_30')}">
                {{apply(day.Day_30)}}
                <span class="prediction" ng-if="day.Day30_Prediction">({{ apply(day.Day30_Prediction) }})</span>
            </td>
            <td ng-style="{'background-color': apply_color(day.Day_60, 'Day_60')}">
                {{apply(day.Day_60)}}
                <span class="prediction" ng-if="day.Day90_Prediction">({{ apply(day.Day90_Prediction) }})</span>
            </td>
            <td ng-style="{'background-color': apply_color(day.Day_90, 'Day_90')}">
                {{apply(day.Day_90)}}
                <span class="prediction" ng-if="day.Day90_Prediction">({{ apply(day.Day90_Prediction) }})</span>
            </td>
            <td ng-style="{'background-color': apply_color(day.Day_120, 'Day_120')}">
                {{apply(day.Day_120)}}
                <span class="prediction" ng-if="day.Day120_Prediction">({{apply(day.Day120_Prediction)}})</span>
            </td>
            <td ng-style="{'background-color': apply_color(day.Day_150, 'Day_150')}">
                {{apply(day.Day_150)}}
                <span class="prediction" ng-if="day.Day150_Prediction">({{apply(day.Day150_Prediction)}})</span>
            </td>
            <td ng-style="{'background-color': apply_color(day.Day_180, 'Day_180')}">
                {{apply(day.Day_180)}}
                <span class="prediction" ng-if="day.Day180_Prediction">({{apply(day.Day180_Prediction)}})</span>
            </td>
            <td ng-style="{'background-color': apply_color(day.Day_365, 'Day_365')}">{{apply(day.Day_365)}}</td>
            <td ng-style="{'background-color': apply_color(day.Day_540, 'Day_540')}">{{apply(day.Day_540)}}</td>
            <td ng-style="{'background-color': apply_color(day.Day_720, 'Day_720')}">{{apply(day.Day_720)}}</td>
            <td ng-style="{'background-color': apply_color(day.Max_Date, 'Max_Date')}">{{apply(day.Max_Date)}}</td>
        </tr>
    </table>
</div>
`;
// Exports
module.exports = code;